// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1gdTh","inputDescription":"styles_inputDescription__y3r-N"};